import { set, get, unset } from 'lodash'

const cache = {
  mutations: {
    SET_CACHE_INFO (state, { pageKey, apiKey, data }) {
      const cache = JSON.parse(localStorage.getItem(pageKey)) || {}
      localStorage.setItem(pageKey, JSON.stringify(set(cache, apiKey, data)))
    },
    CLEAR_CACHE_INFO(state, pageKey) {
      localStorage.removeItem(pageKey)
    },
    CLEAR_CACHE_INFO_API(state, { pageKey, apiKey }) {
      const cache = JSON.parse(localStorage.getItem(pageKey)) || {}
      unset(cache, apiKey)
      localStorage.setItem(pageKey, JSON.stringify(cache))
    }
  },
  actions: {
    GetCacheInfo({ commit }, { pageKey, apiKey }) {
      return new Promise(resolve => {
        resolve(get(JSON.parse(localStorage.getItem(pageKey)), apiKey))
      })
    }
  }
}

export default cache
